import {commonEventEmitter} from "../commonEventEmitter";

class AdditionalCatalogFilter {
  #formElement;

  #currentCheckedElement = null;

  #eventEmitter = commonEventEmitter;

  constructor() {
    this.#formElement = document.querySelector(`.js-additional-catalog-filter`);

    if (!this.#formElement) return;

    this.onFormChange = this.onFormChange.bind(this);
    this.update = this.update.bind(this);

    this.#formElement.addEventListener(`change`, this.onFormChange);
    this.#eventEmitter.on(`additional-filter.update`, this.update);

    this.#initFirstCheckElement();
  }

  #checkedElementFromSearchParams() {
    const decodeSearchString = decodeURI(window.location.search);

    const regexp = /(F(\[properties\])*\[[a-zA-Zа-яёА-ЯЁ+\/]+\](\[\])*=[a-zA-Zа-яёА-ЯЁ+\/0-9]+&)/g;

    const matchAll = Array.from(decodeSearchString.matchAll(regexp));

    if (matchAll.length !== 1) return;

    const checkedInput = Array.from(this.#formElement.elements).find((element) => {
      return matchAll[0][0].replace(`&`, ``) === `${element.name}=${element.value}`;
    });

    if (!checkedInput) return;

    checkedInput.checked = true;

    this.#currentCheckedElement = checkedInput;
  }

  /**
   * Проверяет регуляркой есть ли фильтрация.
   * Если есть проверяет что был отфильтрован по одному параметру
   * И если этот параметр совпадает с доп фильтрацие, то включает данный чекбокс
   */
  #initFirstCheckElement() {
    this.#checkedElementFromSearchParams();
  }

  update() {
    this.#formElement.reset();
    this.#checkedElementFromSearchParams();
  }

  onFormChange(evt) {
    const target = evt.target;

    if (this.#currentCheckedElement && target !== this.#currentCheckedElement) {
      this.#currentCheckedElement.checked = false;
    }

    this.#currentCheckedElement = target;

    this.#eventEmitter.emit(`catalog-filter.reset`);
    this.#eventEmitter.emit(`catalog-filter.set-filter`, {
      name: this.#currentCheckedElement.name,
      value: this.#currentCheckedElement.value,
      isChecked: this.#currentCheckedElement.checked,
    });
  }
}

export {AdditionalCatalogFilter};
